import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-configuration-delete-confirmation-dialog',
    templateUrl: './transaction-log-resolve-confirmation-dialog.component.html',
    styleUrls: ['./transaction-log-resolve-confirmation-dialog.component.scss'],
    standalone: false
})
export class TransactionLogResolveConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
  }


  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
